import { resolve } from '@/core/di';
import { PublicWorkstationRepository } from './api/PublicWorkstationRepository';

export const workstationRepository = (): PublicWorkstationRepository =>
  resolve(PublicWorkstationRepository);
